/** עזרי תצוגה משותפים למסכים שפונים לשרת. */

import { describeVisitError } from '../visits/data.ts';

export function describeError(error: unknown): string {
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String((error as { message: unknown }).message)
      : String(error);
  if (/Invalid login credentials/i.test(message)) return 'דוא״ל או סיסמה שגויים.';
  if (/Email not confirmed/i.test(message)) return 'כתובת הדוא״ל טרם אומתה.';
  if (/admin role required/i.test(message)) return 'נדחה בשרת: הפעולה מותרת למנהל בלבד.';
  if (/row-level security/i.test(message)) return 'נדחה בשרת: אין הרשאה לפעולה.';
  if (/Password should be/i.test(message)) return 'הסיסמה קצרה מדי (לפחות 8 תווים).';
  // D35 — מחיקת אתר לצמיתות (לפני כללי הביקור: ״only an organization admin…״ של D27 דומה).
  if (/delete a site/.test(message)) return 'רק מנהל הארגון רשאי למחוק אתר לצמיתות.';
  if (/site name does not match/.test(message)) return 'השם שהוקלד אינו שם האתר — שום דבר לא נמחק.';
  // בדיוק ״site not found״ — לא ״site not found or archived / or not editable״ של פעולות אחרות.
  if (/^site not found$/.test(message)) return 'האתר כבר לא קיים — ייתכן שנמחק במכשיר אחר.';
  const visitRule = describeVisitError(message);
  if (visitRule !== null) return visitRule;
  // כללי תיק האתר (שלב 3) — נאכפים בשרת; ההודעה מסבירה מה לתקן.
  if (/area_name_per_site/i.test(message)) return 'כבר קיים באתר אזור פעיל בשם הזה.';
  if (/beyond the document/i.test(message)) return 'מספר העמוד גדול ממספר העמודים במסמך.';
  if (/belongs to another (site|document)/i.test(message))
    return 'הפריט שנבחר שייך לאתר או למסמך אחר. רעננו ובחרו שוב.';
  if (/not found in storage/i.test(message))
    return 'הקובץ לא נמצא באחסון — ייתכן שההעלאה נקטעה. נסו להעלות שוב.';
  if (/document is archived/i.test(message)) return 'המסמך בארכיון; אי אפשר להוסיף לו גרסה.';
  if (/violates check constraint/i.test(message)) return 'אחד הערכים אינו תקין. בדקו את השדות.';
  return message;
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleString('he-IL', { dateStyle: 'short', timeStyle: 'short' });
}

/** שמות קבצים בעברית נדחים כנתיב אחסון — הנתיב נשמר באותיות לטיניות. */
export function storageSafeName(name: string): string {
  const dot = name.lastIndexOf('.');
  const ext =
    dot > 0
      ? name
          .slice(dot)
          .toLowerCase()
          .replace(/[^a-z0-9.]/g, '')
      : '';
  const base = (dot > 0 ? name.slice(0, dot) : name).replace(/[^A-Za-z0-9_-]+/g, '_');
  return `${base.replace(/^_+|_+$/g, '') || 'file'}${ext}`.slice(0, 120);
}
